import store from '@/store'

export const ContractHelper = {
  /**
   *
   * @param {Basket} payload
   * @return {Promise<Basket>}
   */
  async loadContract(payload) {
    if (!payload.existingCustomer) return payload

    await store.dispatch('contract/setContract', payload)
    return payload
  },
}
